import { Reducer } from 'redux';
import { FEEDBACK_FETCH_SUCCESS, IFeedbackFetchAction } from '../actions/feedback';
import { IFeedbackState } from '../types/feedback';

export const initialState: IFeedbackState = {
  feedback: [],
  meta: {
    has_next: false,
    has_previous: false,
  },
};

const reducer: Reducer<IFeedbackState> = (
  state: IFeedbackState = initialState,
  action: IFeedbackFetchAction
) => {
  switch (action.type) {
    case FEEDBACK_FETCH_SUCCESS:
      return { feedback: action.payload.feedback, meta: action.payload.meta };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/feedback.ts